//
// TextElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "../../models/visualElements/TextElement";

var TextElementController = createModule("BIRD::TextElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getFormattedText: [7],
        getModel: [1],
        triggerInteraction: [0,7],
        getRichTextAsHTML: [7],
        showTooltip: [0],
        getMaxFontHeight: [5],
        getPlainText: [7],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default TextElementController;
